import { gql } from "@apollo/client";

export const DELETE_EXCLUSION = gql`
  mutation deleteMemberVenueExclusion($id: ID!, $partnerId: ID!) {
    deleteMemberVenueExclusion(id: $id, partnerId: $partnerId) {
      id
    }
  }
`;
